<template>
  <v-responsive class="overflow-y-auto" max-height="calc(80vh - 320px)">
    <v-data-table
      v-model="selectedStudent"
      :options.sync="studentTableOptions"
      :server-items-length="totalItems"
      :headers="headers"
      :items-per-page="5"
      :items="students"
      :footer-props="footerTable"
      loading-text="Đang Tải"
      show-select
      :loading="loading"
      disable-sort
      ref="clear"
    >
      <template v-slot:top="{ pagination, options, updateOptions }">
        <v-data-footer
          :items-per-page="5"
          :page-text="pageText"
          :pagination="pagination"
          :options="options"
          :items-per-page-options="totalItems > 100 ? [5, 10, 15] : [5, 10, 15, -1]"
          @update:options="updateOptions"
          items-per-page-text="Học viên mỗi trang"
          items-per-page-all-text="Tất cả"
        />
      </template>
      <template v-slot:[`item.name`]="{ item }">
        <card-student-name :student="item" link />
      </template>
      <template v-slot:[`item.dob`]="{ item }">
        <span>{{ item.dob | ddmmyyyy }}</span>
      </template>
      <template v-slot:[`item.currentClass`]="{ item }">
        <router-link style="text-decoration: none" :to="'/class/' + (item.currentClass && item.currentClass.id)">
          <span v-if="item.currentClass">{{ item.currentClass | getCurrentClass }}</span>
        </router-link>
      </template>
    </v-data-table>
  </v-responsive>
</template>
<script>
import CardStudentName from '@/components/basic/card/CardStudentName.vue'
import { mapState, mapActions, mapMutations } from 'vuex'
const originHeaders = [
  {
    text: 'Tên học viên',
    value: 'name',
  },
  {
    text: 'Ngày sinh',
    value: 'dob',
  },
  {
    text: 'Lớp',
    value: 'currentClass',
    width: '100',
  },
]

export default {
  data() {
    return {
      headers: this.propHeaders && this.propHeaders.length ? this.propHeaders : originHeaders,
      originHeaders: originHeaders,
      studentTableOptions: {},
      selectedStudent: [],
    }
  },

  components: {
    CardStudentName,
  },
  computed: {
    ...mapState('students', ['totalItems', 'students', 'pageText', 'loading', 'studentSearchParams']),
    footerTable() {
      let footer = {
        'items-per-page-text': 'Số học viên mỗi trang',
        'items-per-page-all-text': 'Tất cả',
        'items-per-page': 5,
        'page-text': this.pageText,
      }
      if (this.totalItems > 100) {
        footer['items-per-page-options'] = [5, 10, 15]
      }
      return footer
    },
  },
  methods: {
    ...mapActions('students', ['requestPageSettings', 'searchStudents']),
    ...mapMutations('postCreate', ['setSelectedStudent']),
    async refresh(query) {
      await this.searchStudents({ ...query })
    },
    getTuitionStatus(leads) {
      if (!leads) return ''
      return leads
        .map((lead) => {
          return lead.liabilities
        })
        .reduce((a, b) => a + b, 0) >= 0
        ? ''
        : 'Nợ'
    },
    getColor(status) {
      switch (status) {
        case 'active':
          return '#46BE8A'
        case 'reserved':
          return 'orange'
        case 'graduated':
          return 'primary'
        case 'left':
          return 'red'
        default:
          return 'grey'
      }
    },
    clearSelected() {
      this.selectedStudent = []
    },
  },
  async created() {
    await this.refresh({ ...this.filter })
  },
  filters: {
    getStatus(status) {
      switch (status) {
        case 'active':
          return 'Đang học'
        case 'reserved':
          return 'Bảo lưu'
        case 'graduated':
          return 'Đã tốt nghiệp'
        case 'left':
          return 'Đã nghỉ'
      }
    },
    getClassCount(classes) {
      return classes ? classes.length : 0
    },
    getClasses(classes) {
      if (classes && classes.length > 0) {
        return classes.map((c) => c.title).join(' ,')
      } else return ''
    },
    getCurrentClass(currentClass) {
      return currentClass == null ? '' : currentClass.title
    },
  },
  watch: {
    studentTableOptions: {
      handler(newOptions, oldOptions) {
        const itemPerPageChanged = newOptions.itemsPerPage !== oldOptions.itemsPerPage
        const pageChanged = newOptions.page !== oldOptions.page
        if (pageChanged || itemPerPageChanged) {
          this.requestPageSettings({
            page: newOptions.page,
            itemsPerPage: newOptions.itemsPerPage,
          })
        }
      },
      deep: true,
    },
    selectedStudent: {
      handler() {
        this.setSelectedStudent(this.selectedStudent)
      },
    },
  },
}
</script>
<style scoped>
.nowrap {
  white-space: nowrap;
  overflow-x: hidden;
  text-overflow: ellipsis;
  width: 230px;
}
</style>
